import { random } from './utils/math'
import { TimelineLite, Power2 } from 'gsap'
import bus from './bus'
import UI from './utils/UI'

UI({
  component: '.js-singleProduct',
  items: ['.js-singleProduct-item'],
  schema: '.js-singleProduct-schema'
}, ({ component, items, schema }) => {
  const tl = new TimelineLite({ paused: true })
  const schemaObject = JSON.parse(schema.innerHTML)

  items.forEach(item => {
    item.style.opacity = 1
    tl.from(item, item.clientWidth / 800, {
      x: item.dataset.animateFrom === 'left' ? -item.clientWidth : window.innerWidth + item.clientWidth,
      y: random(-150, 150),
      rotation: random(20, 40) * random([-1, 1]),
      ease: Power2.easeOut
    }, '-=0.35')
  })

  tl.call(_ => bus.emit('single-product-ready'), null, null, tl.totalDuration() * 0.4)
  tl.paused(false)
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ ...schemaObject, productName: schemaObject.name, event: 'productViewed' })
})
